import axiosIns from '@/libs/axios'
import { objectToUrlParam } from '@/libs/helper'

export default class MetatraderAutomaticCryptoDepositApis {
  createWallet = async data => await axiosIns.post(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/crypto-online/wallet/create`, data)

  getActiveWallet = async () => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/crypto-online/wallet/get-active-wallet`)

  deactivateDeposit = async () => await axiosIns.post(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/crypto-online/wallet/deactivate`)

  extendWalletExpiry = async data => await axiosIns.post(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/crypto-online/wallet/extend-expiry`, data)

  getDeposits = async () => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/crypto-online/wallet/deposits`)

  cryptoCurrencyList = async data => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/crypto-online/wallet/currency`, { params: data })

  extendDeposit = async data => await axiosIns.post(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/crypto-online/wallet/extend-expiry`, data)
}
